import { PDFDocument } from 'pdf-lib';
import axiosInstance from '../../config/axiosInstance';
import ReportService from "../Setup/controller/ReportController/ReportController";
import JasperReportService from '../Dashboard/Controller/JasperReportController';

export const getMergedPDFBlob = async ({
    moduleId,
    navigate,
    reportId = null,
    defaultReportID=null,
    currentInputValues = {},
    includeTerms = true,
    setReportLink = () => { },
    setReportTitle = () => { },
    setError = () => { }
}) => {

    try {

        // Default values
        const finalInputValues = {
            ClientID: localStorage.getItem("CompanyID"),
            UserID: localStorage.getItem("UserID"),
            ...currentInputValues
        };

        const redirectCallback = () => {
            navigate('/');
        };

        // ================= MAIN REPORT =================

        let finalReportID = reportId;

        // Get default report if reportId not passed
        if (!finalReportID) {

            let reportData = await ReportService.GetCompanyReports(
                redirectCallback,
                moduleId
            );

            reportData = reportData.filter(
                x => x.IsDefault.toString() === "1"
            );

            finalReportID =
                reportData.length > 0
                    ? reportData[0].ID
                    : defaultReportID;
        }

        const JasperReport =
            await JasperReportService.GetJasperReportByID(finalReportID);

        let url = JasperReport[0].Link;

        setReportLink(url);

        setReportTitle(JasperReport[0].ReportTitle);

        // Replace placeholders dynamically
        Object.keys(finalInputValues).forEach((key) => {

            const placeholder = new RegExp(`{${key}}`, 'g');

            if (url.includes(`{${key}}`)) {

                url = url.replace(
                    placeholder,
                    finalInputValues[key]
                );
            }
        });

        const queryObjMain = {
            ...finalInputValues,
            format: 'pdf',
            ReportName: JasperReport[0].ReportName,
            ReportType: JasperReport[0].ReportType,
            name: JasperReport[0].ReportName
        };

        const queryStringMain =
            new URLSearchParams(queryObjMain).toString();

        const responseMain = await axiosInstance.get(
            `/Dashboard/ProxyReport?${queryStringMain}`,
            { responseType: 'blob' }
        );

        const mainPdfBytes =
            await responseMain.data.arrayBuffer();

        const mergedPdf = await PDFDocument.create();

        const mainPdf =
            await PDFDocument.load(mainPdfBytes);

        const mainPages =
            await mergedPdf.copyPages(
                mainPdf,
                mainPdf.getPageIndices()
            );

        mainPages.forEach((page) => {
            mergedPdf.addPage(page);
        });

        const mergedPdfBytes = await mergedPdf.save();

        return new Blob(
            [mergedPdfBytes],
            { type: "application/pdf" }
        );

    } catch (err) {

        console.error("Error executing report:", err);

        setError("Failed to execute the report.");

        return null;
    }
};